<example-shell
  exampleId="sorting" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Sortable inventory"
    [columns]="inventoryColumns"
    [data]="inventory"
    defaultSortFieldId="stock"
    [defaultSortAsc]="false"
    [striped]="true"
    [highlightOnHover]="true"
    (sortChange)="record('inventory sort', $event)">
  </stackline-data-table>
</example-shell>
